// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectExternalLinkRemoveMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PFIX_EXTERNAL_LINK_REMOVE_MESSAGE);
        this.Id = null;
    }
}
